import { render, staticRenderFns } from "./ShopWindow.vue?vue&type=template&id=38cc8270&scoped=true&"
import script from "./ShopWindow.vue?vue&type=script&lang=js&"
export * from "./ShopWindow.vue?vue&type=script&lang=js&"
import style0 from "./ShopWindow.vue?vue&type=style&index=0&id=38cc8270&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38cc8270",
  null
  
)

export default component.exports